/**
 * 音频播放时间换算
 * @param {number} value - 音频当前播放时间，单位秒
 */
export const transTime = value => {
  let time = "";
  const h = parseInt(value / 3600);
  value %= 3600;
  const m = parseInt(value / 60);
  const s = parseInt(value % 60);
  if (h > 0) {
    time = formatTime(h + ":" + m + ":" + s);
  } else {
    time = formatTime(m + ":" + s);
  }

  return time;
};

/**
 * 格式化时间显示，补零对齐
 * eg：2:4  -->  02:04
 * @param {string} value - 形如 h:m:s 的字符串
 */
export const formatTime = value => {
  let time = "";
  const s = value.split(":");
  let i = 0;
  for (; i < s.length - 1; i++) {
    time += s[i].length === 1 ? "0" + s[i] : s[i];
    time += ":";
  }
  time += s[i].length === 1 ? "0" + s[i] : s[i];

  return time;
};

export const setDateTime = newVal => {
  let result = "刚刚";
  const minute = 1000 * 60;
  const hour = minute * 60;
  const day = hour * 24;
  const month = day * 30;
  const now = new Date().getTime();
  const diffValue = now - Date.parse(newVal.replace(/-/g, "/"));
  if (diffValue < 0) {
    return result;
  }
  const monthC = diffValue / month;
  const weekC = diffValue / (7 * day);
  const dayC = diffValue / day;
  const hourC = diffValue / hour;
  const minC = diffValue / minute;

  if (monthC >= 1) {
    result = "" + parseInt(monthC) + "个月前";
  } else if (weekC >= 1) {
    result = "" + parseInt(weekC) + "周前";
  } else if (dayC >= 1) {
    result = "" + parseInt(dayC) + "天前";
  } else if (hourC >= 1) {
    result = "" + parseInt(hourC) + "小时前";
  } else if (minC >= 1) {
    result = "" + parseInt(minC) + "分钟前";
  } else {
    result = "刚刚";
  }
  return result;
};

export const isWechat = () => {
  const ua = window.navigator.userAgent.toLowerCase();
  return ua.match(/MicroMessenger/i) === "micromessenger";
};

export const parseQueryString = urlStr => {
  // 参数的字符串
  var paramsStr = urlStr.slice(1);
  // 声明对象
  var obj = {};
  // 把参数添加到对象中
  var paramsArr = paramsStr.split("&");
  // 数组循环
  paramsArr.forEach(function(element) {
    var [key, value] = element.split("=");
    // 往对象里添加内容
    obj[key] = value;
  });
  // 返回对象
  return obj;
};

export const isPc = () => {
  var userAgentInfo = navigator.userAgent;
  var Agents = [
    "Android",
    "iPhone",
    "SymbianOS",
    "Windows Phone",
    "iPod",
    "iPad"
  ];
  var flag = true;
  for (var i = 0; i < Agents.length; i++) {
    if (userAgentInfo.indexOf(Agents[i]) > 0) {
      flag = false;
      break;
    }
  }
  return flag;
};

export const UrlSearch = () => {
  var obj = {};
  var name, value;
  var str = location.href; //取得整个地址栏
  var num = str.indexOf("?");
  str = str.substr(num + 1); //取得所有参数 stringvar.substr(start [, length ]

  var arr = str.split("&"); //各个参数放到数组里
  for (var i = 0; i < arr.length; i++) {
    num = arr[i].indexOf("=");
    if (num > 0) {
      name = arr[i].substr(0, num);
      value = arr[i].substr(num + 1);
      obj[name] = value;
    }
  }
  return obj;
};
